import React, { useMemo } from 'react';
import InventoryMetaPage from '../components/inventory/InventoryMetaPage';

export default function WarrantiesPage() {
    const columns = useMemo(() => [
        { key: 'name', label: 'Warranty' },
        { key: 'description', label: 'Description' },
        { key: 'duration', label: 'Duration' },
        { key: 'status', label: 'Status' },
    ], []);

    return (
        <InventoryMetaPage
            title="Warranties"
            type="warranty"
            columns={columns}
            fields={[
                { name: 'name', label: 'Warranty Name' },
                { name: 'duration', label: 'Duration', placeholder: 'e.g. 12 months' },
                { name: 'description', label: 'Description', type: 'textarea' },
            ]}
            buildPayload={(form) => ({
                name: form.name,
                description: form.description,
                status: form.status,
                metadata: {
                    duration: form.duration,
                },
            })}
        />
    );
}
